import { useState, useCallback } from "react";
import { DatabaseEnum } from "@Shape-Digital/kudzu-data/lib/types/common";
import { CenterRadiologist } from "./useCenterRadiologists";

const NON_RADIOLOGIST_EDIT_ROLES: DatabaseEnum["center_user_role"][] = [
  "super_admin",
  "regional_admin",
  "receptionist",
  "technologist",
];

type UseEditModeParams = {
  permissions: DatabaseEnum["center_user_role"][];
  currentUserId: string;
  radiologists: CenterRadiologist[];
};

const useEditMode = ({
  permissions,
  currentUserId,
  radiologists,
}: UseEditModeParams) => {
  const [isEditMode, setIsEditMode] = useState(false);

  const isRadiologistOnly =
    permissions.includes("radiologist") &&
    !NON_RADIOLOGIST_EDIT_ROLES.some((r) => permissions.includes(r));

  const currentUserInRadList = radiologists.some((r) => r.id === currentUserId);

  const canEdit = !isRadiologistOnly || currentUserInRadList;

  const editableRadiologistIds = isRadiologistOnly
    ? [currentUserId]
    : radiologists.map((r) => r.id);

  const onEditClick = useCallback(() => {
    setIsEditMode(true);
  }, []);

  const onCancelEdit = useCallback(() => {
    setIsEditMode(false);
  }, []);

  return {
    isEditMode,
    canEdit,
    isRadiologistOnly,
    editableRadiologistIds,
    onEditClick,
    onCancelEdit,
  };
};

export default useEditMode;
